import Blue from "~/core";

new Blue({
    name: 'animateIO',
    selector: ".animateIO",
    setup(animateIO) {

        // Remove the transition class
        const stat1 = document.querySelector('.stat1');
        const stat2 = document.querySelector('.stat2');
        const stat3 = document.querySelector('.stat3');
        const stat4 = document.querySelector('.stat4');
        const stat5 = document.querySelector('.stat5');
        stat1.classList.remove('animate__fadeInDown')
        stat2.classList.remove('animate__fadeInUp')
        stat3.classList.remove('animate__fadeInDown')
        stat4.classList.remove('animate__fadeInRight')
        stat5.classList.remove('animate__fadeInUp')


        // Create the observer
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stat1.classList.add('animate__fadeInDown');
                    stat2.classList.add('animate__fadeInUp')
                    stat3.classList.add('animate__fadeInDown')
                    stat4.classList.add('animate__fadeInRight')
                    stat5.classList.add('animate__fadeInUp')

                    return;
                }
                stat1.classList.remove('animate__fadeInDown');
                stat2.classList.remove('animate__fadeInUp')
                stat3.classList.remove('animate__fadeInDown')
                stat4.classList.remove('animate__fadeInRight')
                stat5.classList.remove('animate__fadeInUp')

            });
        });

        observer.observe(document.querySelector('.animate__animated'));
    }
});